var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgArrowSe = function SvgArrowSe(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0582 5.54805C4.61858 5.54733 5.0761 6.00483 5.07538 6.56519L5.07538 9.85974L11.9719 2.96347C12.3676 2.56784 13.015 2.56784 13.4107 2.96347C13.807 3.35983 13.8063 4.00651 13.4107 4.40214L6.51411 11.2984L9.80953 11.2991C10.3692 11.2991 10.8267 11.7566 10.8267 12.3163C10.8267 12.8759 10.3692 13.3334 9.80953 13.3334L4.0582 13.3327C3.97331 13.3341 3.89706 13.3039 3.81865 13.2845C3.77045 13.2723 3.7201 13.2737 3.67262 13.255C3.63018 13.2385 3.59709 13.2054 3.55896 13.1816C3.36545 13.0701 3.20503 12.9083 3.11871 12.7011C3.10072 12.6558 3.10216 12.6069 3.09065 12.5594C3.06979 12.4796 3.04102 12.4033 3.04102 12.3156L3.04102 6.56519C3.04102 6.00555 3.49853 5.54805 4.0582 5.54805Z",
    fill: "currentColor"
  })));
};
export default SvgArrowSe;